/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {Auth0Provider} from "@auth0/auth0-react";
import {Toaster} from "react-hot-toast";


const onRedirectCallback = (appState) => {
    window.history.replaceState(
        {},
        document.title,
        appState?.returnTo || window.location.pathname
    );
};

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const container = document.getElementById('root');
const root = createRoot(container);
const theme = createTheme();
root.render(
  <BrowserRouter basename={baseUrl}>
      <ThemeProvider theme={theme}>
          <Auth0Provider
              domain={process.env.REACT_APP_AUTH0_DOMAIN}
              clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
              authorizationParams={{
                  redirect_uri: window.location.origin,
                  audience: process.env.REACT_APP_AUTH0_AUDIENCE
              }}
              useRefreshTokens={true}
              cacheLocation="localstorage"
              onRedirectCallback={onRedirectCallback}
          >
              <App/>
          </Auth0Provider>
          <Toaster
              position="bottom-center"
              toastOptions={{
                  duration: 5000,
                  style: {
                      borderRadius: '10px',
                      background: '#333',
                      color: '#fff',
                  }
              }}
          />
      </ThemeProvider>
  </BrowserRouter>);

serviceWorkerRegistration.register();